import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import plCommon from "./locales/pl/common.json";
import plCompanies from "./locales/pl/companies.json";
import plContacts from "./locales/pl/contacts.json";
import plEmployees from "./locales/pl/employees.json";
import plProducts from "./locales/pl/products.json";
import plTransactions from "./locales/pl/transactions.json";
import plTransports from "./locales/pl/transports.json";
import plEmails from "./locales/pl/emails.json";
import plDocuments from "./locales/pl/documents.json";
import plInvoices from "./locales/pl/invoices.json";
import plPriceLists from "./locales/pl/price_lists.json";
import plPriceListRequests from "./locales/pl/price_list_requests.json";
import plMisc from "./locales/pl/misc.json";
import plCompanyDocuments from "./locales/pl/company_documents.json";
import plEdpr from "./locales/pl/edpr.json";
import plSettings from "./locales/pl/settings.json";
import plReports from "./locales/pl/reports.json";
import plGmailOAuth from "./locales/pl/gmail-oauth.json";
import plPipeline from "./locales/pl/pipeline.json";
import plDeliveryTargets from "./locales/pl/delivery_targets.json";
import plAppConfiguration from "./locales/pl/app_configuration.json";
import plAudit from "./locales/pl/audit.json";
import plDashboard from "./locales/pl/dashboard.json";
import plBuilder from "./locales/pl/builder.json";
import plBank from "./locales/pl/bank.json";
import plCommission from "./locales/pl/commission.json";
import plQueues from "./locales/pl/queues.json";
import plTable from "./locales/pl/table.json";
import translationEN from "./locales/en.json";

const translationPL = {
  ...plCommon,
  ...plCompanies,
  ...plContacts,
  ...plEmployees,
  ...plProducts,
  ...plTransactions,
  ...plTransports,
  ...plEmails,
  ...plDocuments,
  ...plInvoices,
  ...plPriceLists,
  ...plPriceListRequests,
  ...plMisc,
  ...plCompanyDocuments,
  ...plEdpr,
  ...plSettings,
  ...plReports,
  gmailOAuth: plGmailOAuth,
  pipeline: plPipeline,
  ...plDeliveryTargets,
  ...plAppConfiguration,
  ...plAudit,
  ...plDashboard,
  ...plBuilder,
  ...plBank,
  ...plCommission,
  ...plQueues,
  table: plTable,
  notifications: {
    success: "Sukces",
    error: "Błąd",
    editSuccess: "Zapisano pomyślnie",
    editError: "Błąd podczas zapisu",
    createSuccess: "Utworzono pomyślnie",
    createError: "Błąd podczas tworzenia",
    deleteSuccess: "Usunięto pomyślnie",
    deleteError: "Błąd podczas usuwania",
    undoable: "Cofnij za {{seconds}} s",
  },
};

// The translations
const resources = {
  pl: {
    translation: translationPL
  },
  en: {
    translation: translationEN
  }
};

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "pl", // Default language
    lng: "pl", // Force Polish as default
    
    interpolation: {
      escapeValue: false // React already safes from xss
    },

    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'navigator'],
      // Keys or params to lookup language from
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    }
  });

export default i18n;